import { render, staticRenderFns } from "./crudPHPCallback.vue?vue&type=template&id=1030531e&"
import script from "./crudPHPCallback.vue?vue&type=script&lang=js&"
export * from "./crudPHPCallback.vue?vue&type=script&lang=js&"
import style0 from "./crudPHPCallback.vue?vue&type=style&index=0&id=1030531e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports